module.exports = __webpack_public_path__ + "static/media/bg-image.a7485092.png";